import {
  LinkDocument,
  LinkType,
  MainMenuItem,
  SubmenuItem,
} from '@lglp/prismic-client';

/**
 *
 * @param menuItems list of submenu items
 * this methods return all the document links uid referenced in a submenuitem
 * list recursievely
 */
const getLinksFromMSubMenuItem = (menuItems: SubmenuItem[]): string[] => {
  return menuItems.reduce((acc, menuItem) => {
    if (menuItem.items && menuItem.items.length > 0) {
      return [...acc, ...getLinksFromMSubMenuItem(menuItem.items)];
    } else if (menuItem.link && menuItem.link.linkType === LinkType.Document) {
      return [...acc, (menuItem.link as LinkDocument).id];
    }
    return acc;
  }, []);
};

export const getMainMenuLinksIds = (
  menuItems: MainMenuItem[]
): Record<string, string[]> =>
  menuItems?.reduce(
    (acc, mainMenuItem) => ({
      ...acc,
      [mainMenuItem.label]: getLinksFromMSubMenuItem(mainMenuItem.items),
    }),
    {}
  );
